import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "date-picker-filter"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_multi_mode_date_picker_selector = _resolveComponent("multi-mode-date-picker-selector");
  const _component_filter_item_selector = _resolveComponent("filter-item-selector");
  const _component_dropdown_body = _resolveComponent("dropdown-body");
  const _component_b_dropdown = _resolveComponent("b-dropdown");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_b_dropdown, {
    ref: "dropdown",
    "no-caret": "",
    offset: "8",
    onHidden: $options.handleHidden,
    menuClass: "datepicker-menu"
  }, {
    "button-content": _withCtx(() => [_createVNode(_component_filter_item_selector, {
      "no-caret": $props.noCaret
    }, {
      title: _withCtx(() => [_createVNode(_component_multi_mode_date_picker_selector, {
        loading: $props.loading,
        selector: $props.date,
        pillStyle: $props.pillStyle
      }, {
        body: _withCtx(() => [_renderSlot(_ctx.$slots, "date-picker-body")]),
        _: 3
      }, 8, ["loading", "selector", "pillStyle"])]),
      _: 3
    }, 8, ["no-caret"])]),
    default: _withCtx(() => [_createVNode(_component_dropdown_body, {
      class: "filter-dropdown-body"
    }, {
      default: _withCtx(() => [_renderSlot(_ctx.$slots, "body")]),
      _: 3
    })]),
    _: 3
  }, 8, ["onHidden"])]);
}